import { render, staticRenderFns } from "./expanded-gad7.vue?vue&type=template&id=071e8e2a&scoped=true&lang=pug&"
import script from "./expanded-gad7.vue?vue&type=script&lang=ts&"
export * from "./expanded-gad7.vue?vue&type=script&lang=ts&"
import style0 from "./expanded-gad7.vue?vue&type=style&index=0&id=071e8e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071e8e2a",
  null
  
)

export default component.exports